import { render } from "./NotificationContainer.vue?vue&type=template&id=65bbd23b&scoped=true"
import script from "./NotificationContainer.vue?vue&type=script&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&lang=js"

import "./NotificationContainer.vue?vue&type=style&index=0&id=65bbd23b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bbd23b"]])

export default __exports__